import type { NavigationGuard } from 'vue-router'
import type { RouteNamedMap } from 'vue-router/auto-routes'
import { useFeatureFlags } from '~/composables/useFeatureFlags'
import {
  FEATURE_FLAG,
  type TFeatureFlagKey,
} from '~/constants/types/featureFlags'

const FLAGGED_ROUTE_NAMES = {
  // CHECKLIST: '/tools/annual-checklist',
  AOP: 'action-oriented-programs',
  // GFE: '/tools/good-faith-efforts',
  AUDIT_CENTER: 'audit-center',
  AUDIT_CENTER_CHECKLIST: 'audit-checklist',
} satisfies Record<string, keyof RouteNamedMap>

const FEATURE_MAP: Partial<
  Record<
    (typeof FLAGGED_ROUTE_NAMES)[keyof typeof FLAGGED_ROUTE_NAMES],
    TFeatureFlagKey
  >
> = {
  // [TOOLS_ROUTES.CHECKLIST]: FEATURE_FLAG.COMPLIANCE_CHECKLIST,
  [FLAGGED_ROUTE_NAMES.AOP]: FEATURE_FLAG.ACTION_ORIENTED_PROGRAMS,

  // [TOOLS_ROUTES.GFE]: FEATURE_FLAG.GOOD_FAITH_EFFORTS,
  [FLAGGED_ROUTE_NAMES.AUDIT_CENTER]: FEATURE_FLAG.AUDIT_CENTER,
  [FLAGGED_ROUTE_NAMES.AUDIT_CENTER_CHECKLIST]: FEATURE_FLAG.AUDIT_CENTER,
} satisfies Partial<
  Record<
    (typeof FLAGGED_ROUTE_NAMES)[keyof typeof FLAGGED_ROUTE_NAMES],
    TFeatureFlagKey
  >
>

export const checkFeatureFlagAccessGuard: NavigationGuard = (
  to,
  _from,
  next
) => {
  const { isFeatureEnabled } = useFeatureFlags()

  // check audit center and subpages like checklists
  if (
    to.path.includes('/tools/audit-center') &&
    !isFeatureEnabled(FEATURE_FLAG.AUDIT_CENTER)
  ) {
    return next('/')
  }

  if (
    (Object.values(FLAGGED_ROUTE_NAMES) as (keyof RouteNamedMap)[]).includes(
      to.name
    ) &&
    Object.keys(FEATURE_MAP).includes(to.name) &&
    !!FEATURE_MAP[to.name as keyof typeof FEATURE_MAP] &&
    !isFeatureEnabled(FEATURE_MAP[to.name as keyof typeof FEATURE_MAP]!)
  ) {
    return next('/')
  }

  next()
}
